import React from 'react'
import Hero from '../Components/Hero'
import Header from '../Components/Header'
import ScrollToTop from '../Components/ScrollToTop'
import Partbgnd from '../Components/Partbgnd'
import { motion } from 'framer-motion'
import ScriptureOverlay from '../Components/ScriptureOverlay'
import Footer from '../Components/Footer'
import Welcome from '../Components/Welcome'
import Donation from '../Components/Donation'
// import EventSpotlight from '../Components/EventSpotlight'


const Home = () => {
  return (
    <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.5 }}>
            <div className='App'>
                <ScrollToTop />
                <Partbgnd />
                <ScriptureOverlay />
                <Header />
                {/* <EventSpotlight /> */}
                <Hero />
                <Welcome />
                <Donation />
                <Footer />
                
            </div>
    </motion.div>
    
  )
}

export default Home